// Service to load and search skills from the JSON file
import skillsData from '../../assets/data/skills.json';

// Flatten all skills from all categories into a single array
const getAllSkills = () => {
  const allSkills = [];
  Object.values(skillsData).forEach(categorySkills => {
    allSkills.push(...categorySkills);
  });
  // Remove duplicates (if any) and sort alphabetically
  return [...new Set(allSkills)].sort();
};

// Cache the flattened skills array
const SKILLS_LIST = getAllSkills();

export const searchSkills = (query) => {
  if (!query || query.length < 1) return [];
  
  const lowerQuery = query.toLowerCase();
  return SKILLS_LIST.filter(skill => 
    skill.toLowerCase().includes(lowerQuery)
  ).slice(0, 10); // Limit to 10 suggestions
};

export const getAllSkillSuggestions = () => {
  return SKILLS_LIST;
};